module.exports = __webpack_public_path__ + "static/img/irole.0d81d00.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/bn/irole.png
// module id = cYPT
// module chunks = 7